import React from "react"

/**
 * 책장 분석 로딩 상태 컴포넌트
 */
const LoadingState = React.memo(() => {
  return (
    <div className="flex h-full flex-col items-center justify-center px-4">
      <div className="mb-6 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
      <p className="typo-rl-body2 text-rl-gray-font-caption mb-4 text-center font-normal">
        책장 촬영 분석 결과를 가져오는 중입니다...
      </p>
    </div>
  )
})

LoadingState.displayName = "LoadingState"

export default LoadingState